import { render, staticRenderFns } from "./DownloadPDF.vue?vue&type=template&id=4fa24415"
import script from "./DownloadPDF.vue?vue&type=script&lang=js"
export * from "./DownloadPDF.vue?vue&type=script&lang=js"
import style0 from "./DownloadPDF.vue?vue&type=style&index=0&id=4fa24415&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports